export default "__VITE_ASSET__cc92269d__"